/* istanbul ignore file */
import React from 'react';
import PropTypes from 'prop-types';
import { sendLoyaltyModalEvent } from 'common/util/gtm-helper';
import defaultStyles from 'commonStyles/components/coupon/_loyalty-simplified';
import styleOverrides from 'styles/components/coupon/_loyalty-simplified';
import useStyleOverrides from 'common/components/hooks/use-style-overrides';
import { translate } from 'common/localization';
import BlankAvatar from 'common/icons/loyalty/blank-avatar';
import Button from 'common/components/atoms/button';
import ErrorBox from './coupon-error-box';
import AlertBox from './alert-box';
import { isEmployeeEmail } from 'common/util/loyalty/sign-up';

const LoyaltyCouponSimplifiedRecognized = ({
  disclaimers,
  claimCoupon,
  error,
  profile,
}) => {
  const isEmployee = isEmployeeEmail(profile.login);
  const hasError = Object.keys(error || {}).length > 0;

  const styles = useStyleOverrides(defaultStyles, styleOverrides);
  const siteAbbr = BC.site.code === 'competitivecyclist' ? 'cc' : 'bc';
  const handleclaimCoupon = () => {
    sendLoyaltyModalEvent('join now click', 'nonmember');
    claimCoupon();
  };

  return (
    <>
      <div className={styles.userBanner}>
        <div className={styles.hDivider} />
        <div className={styles.userInfo}>
          {profile.imagePath ? (
            <img
              alt=""
              className={styles.profileImage}
              src={profile.imagePath}
            />
          ) : (
            <BlankAvatar className={styles.profileImage} />
          )}
          <div className={styles.userTextWrapper}>
            <span className={styles.userName}>{profile.displayName}</span>
            <span className={styles.userEmail}>{profile.login}</span>
          </div>
        </div>
        <div className={styles.hDivider} />
      </div>
      {hasError ? (
        <ErrorBox title={error.title} description={error.description} className={styles.errorBox} />
      ) : null}

      {isEmployee && (
        <AlertBox
          title={translate('label.loyalty.coupon.restrictedPerks')}
          description={translate('label.loyalty.coupon.restrictedEmail')}
        />
      )}

      <Button
        className={styles.modalJoinBtn}
        disabled={isEmployee || hasError}
        onClick={handleclaimCoupon}
        primary
      >
        <span>{translate('label.joinPerks')}</span>
      </Button>

      <div className={styles.disclaimer}>
        <span className={styles.disclaimerText}>
          {`${translate('recognized.terms.intro')} `}
          <a className={styles.modalLink} href={`/sc/${siteAbbr}-expedition-perks-loyalty-program-terms-conditions`}>{`${translate('label.terms.conditions')}.`}</a>
        </span>
      </div>

      <div className={styles.hDivider} />

      <div className={styles.disclaimer}>
        <span>{disclaimers.recognized}</span>
      </div>
    </>
  );
};

LoyaltyCouponSimplifiedRecognized.propTypes = {
  disclaimers: PropTypes.object.isRequired,
  claimCoupon: PropTypes.func.isRequired,
  profile: PropTypes.shape({
    imagePath: PropTypes.string,
    displayName: PropTypes.string,
    login: PropTypes.string,
  }).isRequired,
  error: PropTypes.shape({}).isRequired,
};

export default LoyaltyCouponSimplifiedRecognized;
